import script from "./MarkdownBody.vue?vue&type=script&lang=js"
export * from "./MarkdownBody.vue?vue&type=script&lang=js"

import "./MarkdownBody.vue?vue&type=style&index=0&id=1cc9ed13&lang=css"

const __exports__ = script;

export default __exports__